/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listCustomerBitcoinPayments} from '../api'

export const useMutationListCustomerBitcoinPayments = createReactQueryMutationHook('listCustomerBitcoinPayments', listCustomerBitcoinPayments)
